import { Box, ListItem, Table, TableBody, TableCell, TableHead, TableRow, Tooltip } from "@material-ui/core"
import NotInterestedIcon from '@material-ui/icons/NotInterested';
import CreateIcon from '@material-ui/icons/Create';
import RateReviewIcon from '@material-ui/icons/RateReview';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import CalendarViewDayIcon from '@material-ui/icons/CalendarViewDay';
import Title from "../../Imc/Title"

export const ListUserAuth = ({rows, openModalEdit, classes, changeRol, changeStatus, changeMachine, isLoanding}) => {

    const r = rows !== undefined && rows !== null? rows :[]

    const validateRowsTable = (item) => {

        if (item !== undefined && item !== null) {
            return item
        } else {
            return "---"
        }

    }

    return (

        <>
            <Box
                component="span"
                m={1}
                className={`${classes.spreadBox} ${classes.box}`}
            >
                <Title>Estaciones </Title>
            </Box>

            <Table size="small">
                <TableHead>
                    <TableRow align="center">
                        <TableCell align="center">Correo</TableCell>
                        <TableCell align="center">Telefono</TableCell>
                        <TableCell align="center">User Name</TableCell>
                        <TableCell align="center">Rol</TableCell>
                        <TableCell align="center">Status</TableCell>
                        <TableCell align="center"colSpan="4">Acciones</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody >
                    {isLoanding? <>Cargando...</>: r.map((row) => (

                        <TableRow key={row.id} >
                            <TableCell align="center">{validateRowsTable(row.email)}</TableCell>
                            <TableCell align="center">{validateRowsTable(row.phone)}</TableCell>
                            <TableCell align="center">{validateRowsTable(row.username)}</TableCell>
                            <TableCell align="center">{validateRowsTable(row.roles[0].name)}</TableCell>
                            <TableCell align="center">{validateRowsTable(row.status != false ? 'Activo' : 'Inactivo')}</TableCell>

                            <TableCell align="center" onClick={() => { openModalEdit(row) }}>
                                <ListItem button >
                                    <Tooltip title="Editar" aria-label="top-end">
                                        <CreateIcon color="primary" />
                                    </Tooltip>
                                </ListItem>
                            </TableCell>

                            <TableCell align="center" onClick={() => {changeStatus(row)}}>
                                <ListItem button >
                                    <Tooltip title={row.status?"Inhabilitar": "Habilitar"} aria-label="top-end">
                                    {row.status? <CheckCircleOutlineIcon  color="primary"/> :<NotInterestedIcon color="primary" /> }
                                    </Tooltip>
                                </ListItem>
                            </TableCell>

                            
                            <TableCell align="center" onClick={() => {changeRol(row)}}>
                                <ListItem button >
                                    <Tooltip title="Cambiar Rol" aria-label="top-end">
                                        <RateReviewIcon color="primary" />
                                    </Tooltip>
                                </ListItem>
                            </TableCell>


                            <TableCell align="center" onClick={() => {changeMachine(row)}}>
                                <ListItem button >
                                    <Tooltip title="Asignar Estacion" aria-label="top-end">
                                        <CalendarViewDayIcon color="primary" />
                                    </Tooltip>
                                </ListItem>
                            </TableCell>


                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </>
    )
}